import { atom } from 'jotai'

/** True once a token refresh has failed and the user must sign in again. */
export const sessionExpiredAtom = atom(false)

let mountedSessionExpiredDialogs = 0

/**
 * Registers a mounted session-expired dialog. While one is mounted, a failed
 * token refresh shows it instead of logging out and reloading immediately.
 *
 * @returns an unregister function for effect cleanup.
 */
export const registerSessionExpiredDialog = () => {
  mountedSessionExpiredDialogs += 1
  return () => {
    mountedSessionExpiredDialogs -= 1
  }
}

export const isSessionExpiredDialogMounted = () =>
  mountedSessionExpiredDialogs > 0
